import { useMemo } from "react"
import ILineItem from "~/interfaces/ILineItem"
import { CampingStyleProps, CampProps } from "~/interfaces"

export const usePosModal = (
  lineItems: Partial<ILineItem>[] | undefined,
  camp: CampProps,
  campingStyle: CampingStyleProps | undefined,
) => {
  const availableDiscounts = useMemo(() => {
    return [...camp.discounts, ...(campingStyle?.discounts || [])]
  }, [camp, campingStyle])

  const discountFromLineItems = useMemo(() => {
    if (!lineItems || !camp) return undefined

    const discountIds = lineItems.map((li) => li.discount_id).filter(Boolean) || []
    return availableDiscounts.find((discount) => discountIds.includes(discount.id))
  }, [lineItems, availableDiscounts])

  return { availableDiscounts, discountFromLineItems }
}
